import { render, staticRenderFns } from "./SIADetailInfo.vue?vue&type=template&id=6e117e30&scoped=true"
import script from "./SIADetailInfo.vue?vue&type=script&lang=js"
export * from "./SIADetailInfo.vue?vue&type=script&lang=js"
import style0 from "./SIADetailInfo.vue?vue&type=style&index=0&id=6e117e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e117e30",
  null
  
)

export default component.exports